import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "assets-container" }
const _hoisted_2 = { class: "assets-header" }
const _hoisted_3 = { class: "assets-header-left" }
const _hoisted_4 = { class: "assets-header-left-text" }
const _hoisted_5 = { class: "assets-overview" }
const _hoisted_6 = { class: "assets-value-section" }
const _hoisted_7 = { class: "net-value-header" }
const _hoisted_8 = { class: "net-value-label" }
const _hoisted_9 = { class: "currency-selector-wrapper" }
const _hoisted_10 = { class: "currency-text" }
const _hoisted_11 = {
  key: 0,
  class: "dialog-currency-list"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "net-value-total" }
const _hoisted_14 = { class: "net-value-amount" }
const _hoisted_15 = { class: "net-value-currency" }
const _hoisted_16 = {
  key: 1,
  class: "net-value-amount"
}
const _hoisted_17 = { class: "assets-type-cards" }
const _hoisted_18 = { class: "assets-type-card-info" }
const _hoisted_19 = { class: "assets-type-card-name" }
const _hoisted_20 = {
  key: 0,
  class: "assets-type-card-value"
}
const _hoisted_21 = {
  key: 1,
  class: "assets-type-card-value"
}

import { Transition } from 'vue'
import { formatThousandsKeepDecimal, keepTwoDecimalNoRound } from '@/utils/num_format'
import { computed, onMounted, reactive, ref } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { queryFundAssetAllInfo } from '@/graphql/holdings'
import storage, { StorageType } from '@/utils/storage'
import Decimal from 'decimal.js'
import * as echarts from 'echarts'
import { useStore } from 'vuex'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'
import useHolding from '@/hooks/holdings/useHolding'
import useFundAccMarket from '@/hooks/holdings/useFundAccMarket'

interface Status {
  isShowCurrencyList: boolean
  eyeCloseText: string
  isRefreshing: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Assets',
  setup(__props) {

const store = useStore()
const currencyActive = computed<{ name: string; value: string }>(() => {
  return store.state.holdings.currencyActive
})
const echartsDom = ref<echarts.ECharts | null>(null)

const status: Status = reactive({
  isShowCurrencyList: false,
  eyeCloseText: '**** ****',
  isRefreshing: false
})

const currencyData = ref<{ ccy: string; baseCcy: string; rate: number }[]>([])
const assetsData = ref({
  assetHkd: '0.00',
  assetHkdDispaly: '',
  childs: [],
  assetHkdValue: '0.00'
})

const currencyList = ref([
  { name: '港元', value: 'HKD' },
  { name: '美元', value: 'USD' },
  { name: '人民币', value: 'CNY' }
])

const assetsType = ref<{ name: string; type: string; icon: string; value: string }[]>([
  { name: '股票', type: 'STOCK', icon: 'stock-icon', value: '0.00' },
  { name: '基金', type: 'FUND', icon: 'fund-icon', value: '0.00' },
  { name: '债券', type: 'BOND', icon: 'bond-icon', value: '0.00' },
  { name: '结构化票据', type: 'SPS', icon: 'otc-icon', value: '0.00' },
  { name: '现金', type: 'CASH', icon: 'cash-icon', value: '0.00' },
  { name: '其他', type: 'EXTRA', icon: 'other-icon', value: '0.00' }
])

const echartsData = ref<{ name: string; type: string; value: string; rate: string; itemStyle: { color: string } }[]>([
  { name: '股票', type: 'STOCK', value: '0.00', rate: '', itemStyle: { color: '#249EFF' } },
  { name: '基金', type: 'FUND', value: '0.00', rate: '', itemStyle: { color: '#FF8854' } },
  { name: '债券', type: 'BOND', value: '0.00', rate: '', itemStyle: { color: '#BA66FF' } },
  { name: '结构化票据', type: 'SPS', value: '0.00', rate: '', itemStyle: { color: '#3C70FF' } },
  { name: '现金', type: 'CASH', value: '0.00', rate: '', itemStyle: { color: '#004ACA' } },
  { name: '其他', type: 'EXTRA', value: '0.00', rate: '', itemStyle: { color: '#C9C7C5' } }
])


const userData = computed(() => {
  const userId = storage.rcGetItem(StorageType.local, 'userInfo')
  const userName = storage.rcGetItem(StorageType.local, 'userName')
  return `${userName}账户总览(${userId})`
})

const isShowAssetsDetail = computed(() => store.state.holdings.isShowAssetsDetail)

const formatRatePercent = (rate: string | number) => {
  if (!rate) return '0.00%'
  const rateText = keepTwoDecimalNoRound(new Decimal(rate).mul(100).toString())
  return `${rateText}%`
}

const { onResult, refetch: refetchFundAssetAllInfo } = useQuery(queryFundAssetAllInfo, {
  filter: { fundAccount: storage.rcGetItem(StorageType.local, 'userInfo') }
})

onResult((res) => {
  const { FundAssetAllInfo, EnquireCurrency } = res.data
  if (FundAssetAllInfo.ok) {
    assetsData.value = FundAssetAllInfo.data
    assetsType.value.forEach(item => {
      item.value = FundAssetAllInfo.data.childs.find((child: any) => child.type === item.type)?.assetHkd || '0.00'
    })

    echartsData.value = echartsData.value.map(item => {
      const data = FundAssetAllInfo.data.childs.find((child: any) => child.type === item.type)
      return {
        ...item,
        value: data?.assetHkd || '0.00',
        rate: data?.assetHkdRate || ''
      }
    })

    updateChartData()
  }
  if (EnquireCurrency.ok) {
    currencyData.value = EnquireCurrency.data
  }
})

const updateChartData = () => {
  echartsDom.value?.setOption({
    tooltip: {
      trigger: 'item',
      formatter: (params: { name: string; value: string; percent: number; data: { rate: string | number } }) => {
        const rateText = formatRatePercent(params.data?.rate)
        return `${params.name}: ${formatThousandsKeepDecimal(params.value, 2)}<br />占比: ${rateText}`
      }
    },
    series: [
      {
        type: 'pie',
        center: ['24%', '50%'],
        padAngle: 1,
        stillShowZeroSum: false,
        data: echartsData.value,
        radius: ['45%', '65%'],
        label: {
          fontSize: 10,
          formatter: (params: { name: string; data: { rate: string | number } }) => {
            const rateText = formatRatePercent(params.data?.rate)
            return `{b|${params.name}}\n{d|${rateText}}`
          },
          rich: {
            b: { align: 'left', fontSize: 10 },
            d: { padding: [2, 0, 0, 0], align: 'left', fontSize: 10 }
          }
        }
      }
    ]
  })
}

const formatValue = (num: string) => {
  const rate = currencyData.value.find(item => item.ccy === store.state.holdings.currencyActive.value)?.rate || 1
  return formatThousandsKeepDecimal(new Decimal(num).div(rate).toString(), 2)
}

const currencyClick = (item: { name: string; value: string }) => {
  store.commit(HoldingsMutationTypes.SET_CURRENCY_ACTIVE, item)
  status.isShowCurrencyList = false
  const data = echartsData.value.map(eItem => {
    const rate = currencyData.value.find(cItem => cItem.ccy === store.state.holdings.currencyActive.value)?.rate || 1
    return {
      ...eItem,
      value: new Decimal(eItem.value).div(rate).toString()
    }
  })
  echartsDom.value?.setOption({
    series: [{ data }]
  })
}

const eyeIconClick = () => {
  storage.rcSetItem(StorageType.local, 'isShowAssetsDetail', !isShowAssetsDetail.value)
  store.commit(HoldingsMutationTypes.SET_IS_SHOW_ASSETS_DETAIL, !isShowAssetsDetail.value)
  echartsDom.value?.setOption({
    tooltip: {
      show: isShowAssetsDetail.value,
      trigger: 'item',
      formatter: (params: { name: string; value: string; percent: number }) => {
        return `${params.name}: ${formatThousandsKeepDecimal(params.value, 2)}<br />占比: ${params.percent}%`
      }
    },
    series: [
      {
        label: {
          formatter: (params: { name: string; data: { rate: string | number } }) => {
            if (!isShowAssetsDetail.value) {
              return `{b|${params.name}}`
            }
            const rateText = formatRatePercent(params.data.rate)
            return `{b|${params.name}}\n{d|${rateText}}`
          }
        }
      }
    ]
  })
}

const { queryFundAccData } = useFundAccMarket()
const { queryHoldingData: queryStockData } = useHolding({ exchangeType: 'STOCK' })
const { queryHoldingData: queryFundAndBondData } = useHolding({ exchangeType: 'FUND' })
const { queryHoldingData: queryBondData } = useHolding({ exchangeType: 'BOND' })
const { queryHoldingData: querySpsData } = useHolding({ exchangeType: 'SPS' })
const { queryHoldingData: queryOtherData } = useHolding({ exchangeType: 'EXTRA' })
const shouldQueryFundAccMarketTypes = ['HK', 'US', 'A']

const refreshAssets = async () => {
  if (status.isRefreshing) return
  status.isRefreshing = true
  await refetchFundAssetAllInfo()
  switch (store.state.holdings.accountTypeActive.value) {
    case 'STOCK':
      queryStockData()
      if (shouldQueryFundAccMarketTypes.includes(store.state.holdings.marketTypeActive.value)) {
        queryFundAccData()
      }
      break
    case 'FUND':
      queryFundAndBondData()
      break
    case 'BOND':
      queryBondData()
      break
    case 'SPS':
      querySpsData()
      break
    case 'EXTRA':
      queryOtherData()
      break
    default:
      break
  }
  status.isRefreshing = false
}

onMounted(() => {
  echartsDom.value = echarts.init(document.getElementById('assets-charts') as HTMLElement)
  echartsDom.value.setOption({
    graphic: [{
      type: 'text',
      position: [600 * 0.24, 155 * 0.5],
      style: {
        text: '资产占比',
        textAlign: 'center',
        textVerticalAlign: 'middle',
        fontSize: 10,
        fontFamily: 'PingFang SC',
        fontWeight: 500,
        fill: '#1D2129'
      }
    }],
    legend: {
      show: true,
      right: 0,
      top: 'middle',
      width: 322,
      icon: 'circle',
      itemWidth: 10,
      itemHeight: 10,
      itemGap: 24,
      formatter: (name: string) => `{name|${name}}`,
      textStyle: {
        rich: {
          name: {
            fontFamily: 'PingFang SC',
            fontSize: 12,
            color: '#1D2129',
            lineHeight: 20,
            width: 76
          }
        }
      }
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "assets-header-left-icon" }, null, -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(userData.value), 1)
      ]),
      _createElementVNode("div", {
        class: "assets-header-right",
        onClick: refreshAssets
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "assets-header-right-text" }, "刷新", -1)),
        _createElementVNode("i", {
          class: _normalizeClass(['assets-header-right-icon', { 'rotating': status.isRefreshing }])
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("i", {
              class: _normalizeClass([isShowAssetsDetail.value ? 'eye-icon-open' : 'eye-icon-close']),
              onClick: eyeIconClick
            }, null, 2),
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "net-text" }, "资产净值", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "currency-selector",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (status.isShowCurrencyList = !status.isShowCurrencyList))
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(currencyActive.value.name), 1),
              _createElementVNode("i", {
                class: _normalizeClass(['currency-icon', { 'rotate': status.isShowCurrencyList }])
              }, null, 2)
            ]),
            _createVNode(_Transition, { name: "fade-currency-list" }, {
              default: _withCtx(() => [
                (status.isShowCurrencyList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencyList.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "dialog-currency-list-item",
                          key: item.value
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(['dialog-currency-list-item-text', currencyActive.value.value === item.value ? 'active' : '']),
                            onClick: ($event: any) => (currencyClick(item))
                          }, _toDisplayString(item.name), 11, _hoisted_12)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (isShowAssetsDetail.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(formatValue(assetsData.value.assetHkd)), 1),
                _createElementVNode("span", _hoisted_15, _toDisplayString(currencyActive.value.value), 1)
              ], 64))
            : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(status.eyeCloseText), 1))
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "chart-section" }, [
        _createElementVNode("div", {
          id: "assets-charts",
          class: "assets-charts"
        })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_17, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assetsType.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["assets-type-card", { 'no-border': index === assetsType.value.length - 1 }]),
          key: item.type
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(['assets-type-card-icon', item.icon])
          }, null, 2),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(item.name), 1),
            (isShowAssetsDetail.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(formatValue(item.value)), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(status.eyeCloseText), 1))
          ])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})